import { call, put, takeLatest } from "redux-saga/effects";
import billerRegionsService, {
  BillerRegionsResponse,
  FetchBillerRegionsRequest,
} from "services/api.services/biller/billerRegionsService";
import {
  fetchBillerRegionsRequested,
  fetchBillerRegionsSucceeded,
  fetchBillerRegionsFailed,
} from "./billerRegionsActions";

function* handleFetchBillerRegions(
  action: ReturnType<typeof fetchBillerRegionsRequested>,
) {
  try {
    const payload: FetchBillerRegionsRequest = {
      search: action.payload.search,
      page: action.payload.page, //?? 1,
      limit: action.payload.limit, //?? 20,
      // page: action.payload.page ?? 1,
      // limit: action.payload.limit ?? 20,
    };

    const res: BillerRegionsResponse = yield call(
      billerRegionsService.fetchRegions,
      payload,
    );

    // API se items
    const items = res.billerRegions ?? [];

    yield put(
      fetchBillerRegionsSucceeded({
        items,
        returnItems: res.returnItems ?? items.length,
      }),
    );
  } catch (err: any) {
    const msg = err?.message || "Unable to fetch biller regions";
    yield put(fetchBillerRegionsFailed(msg));
  }
}

export function* billerRegionsSaga() {
  yield takeLatest(fetchBillerRegionsRequested.type, handleFetchBillerRegions);
}
